import { render } from "./StartScreen.vue?vue&type=template&id=01d70296&scoped=true"
import script from "./StartScreen.vue?vue&type=script&lang=js"
export * from "./StartScreen.vue?vue&type=script&lang=js"

import "./StartScreen.vue?vue&type=style&index=0&id=01d70296&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d70296"]])

export default __exports__